import type { RouteRecordRaw } from 'vue-router';

// A4 run-live routes per ADR-007: live dashboard + exceptions +
// override = admin|staff. lifecycle gate = open.
export const routes: RouteRecordRaw[] = [
  {
    path: '/auctions/:id/run-live',
    name: 'run-live',
    component: () => import('./pages/LiveDashboardPage.vue'),
    meta: {
      requiresAdminAuth: true,
      requiredRole: 'any',
      // Pre-live statuses render the Console's introduction state (2026-07-31
      // design decision: the first encounter with the day-of surface should
      // not be during the live event). Exceptions stay open-only.
      lifecycle: ['draft', 'published', 'open'],
    },
  },
  {
    path: '/auctions/:id/run-live/exceptions',
    name: 'run-live-exceptions',
    component: () => import('./pages/ExceptionsPage.vue'),
    meta: {
      requiresAdminAuth: true,
      requiredRole: 'any',
      lifecycle: ['open'],
    },
  },
];
